import { render } from "./Waves.vue?vue&type=template&id=8dd8e432&scoped=true"
import script from "./Waves.vue?vue&type=script&lang=js"
export * from "./Waves.vue?vue&type=script&lang=js"

import "./Waves.vue?vue&type=style&index=0&id=8dd8e432&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8dd8e432"

export default script